export const BLUE_THEME = {
  fontFamily: "'Roboto', 'Helvetica Neue', sans-serif",
  remSize: '16px',
  primary: '--blue-100',
  primaryHover: '--blue-110',
  primaryActive: '--blue-130',
  primary80: '--blue-90',
  primary60: '--blue-50',
  primary40: '--blue-9',
  primary30: '--blue-6',
  primary20: '--blue-4',
  primary10: '--blue-2',

  secondary: '--orange-100',
  secondaryHover: '--orange-130',
  secondaryActive: '--orange-130',
  secondary60: '--orange-50',

  buttonBackground: '--white',
  buttonBorder: '--blue-100',
  buttonText: '--blue-100',
  buttonBackgroundHover: '--white',
  buttonBorderHover: '--blue-110',
  buttonTextHover: '--blue-110',
  buttonBackgroundActive: '--white',
  buttonBorderActive: '--blue-130',
  buttonTextActive: '--blue-130',
  buttonBackgroundDisabled: '--white',
  buttonBorderDisabled: '--black-20',
  buttonTextDisabled: '--black-30',

  // Primary Button
  buttonPrimaryBackground: '--primary',
  buttonPrimaryBorder: '--primary',
  buttonPrimaryText: '--white',
  buttonPrimaryBackgroundHover: '--primary-hover',
  buttonPrimaryBorderHover: '--primary-hover',
  buttonPrimaryTextHover: '--white',
  buttonPrimaryBackgroundActive: '--primary-active',
  buttonPrimaryBorderActive: '--primary-active',
  buttonPrimaryTextActive: '--white',
  buttonPrimaryBackgroundDisabled: '--blue-50',
  buttonPrimaryBorderDisabled: '--blue-50',
  buttonPrimaryTextDisabled: '--white',

  // Secondary Button
  buttonSecondaryBackground: '--orange-100',
  buttonSecondaryBorder: '--orange-100',
  buttonSecondaryText: '--white',
  buttonSecondaryBackgroundHover: '--orange-130',
  buttonSecondaryBorderHover: '--orange-130',
  buttonSecondaryTextHover: '--white',
  buttonSecondaryBackgroundActive: '--orange-130',
  buttonSecondaryBorderActive: '--orange-130',
  buttonSecondaryTextActive: '--white',
  buttonSecondaryBackgroundDisabled: '--orange-50',
  buttonSecondaryBorderDisabled: '--orange-50',
  buttonSecondaryTextDisabled: '--white',

  // Other UI elements
  radioColor: '--blue-100',
  checkboxColor: '--blue-100',
  switchColor: '--green-100',
  switchColorHover: '--green-120',

  bodyFontSize: '--font-size-base',
  h1FontSize: '--font-size-5xl',
  h2FontSize: '--font-size-2xl',
  h3FontSize: '--font-size-lg',
  h4FontSize: '--font-size-base',
  h5FontSize: '--font-size-sm',
  h6FontSize: '--font-size-xs',
  h1FontWeight: '--font-bold',
  h2FontWeight: '--font-medium',
  h3FontWeight: '--font-medium',
  h4FontWeight: '--font-medium',
  h5FontWeight: '--font-medium',
  h6FontWeight: '--font-medium',
  buttonFontWeight: '--font-bold',
}
